import React from 'react';
import c from 'classnames';
import { BiEvent } from '@wix/da-bi/pkg/events';
import { attemptSocialLogin as attemptSocialLoginAction } from '../redux/actions';
import { SocialLoginProvider } from '../types';
import useFacebookSignIn from '../hooks/useFacebookSignIn';
import SocialButtonBase from '../SocialButtonBase';
import SocialButtonIconViewBase from '../SocialButtonIconViewBase';

import s from './SocialButtonFacebook.scss';

export interface Props {
  appId: string;
  biData?: BiEvent;
  className?: string;
  view?: 'standard' | 'icon';
  redirectToJoin?: boolean;
  redirectToSisu?: boolean;
  attemptSocialLogin: typeof attemptSocialLoginAction;
}

const SocialButtonFacebook: React.FC<React.PropsWithChildren<Props>> = ({
  appId,
  biData,
  className,
  view = 'standard',
  redirectToJoin = false,
  redirectToSisu,
  children,
  attemptSocialLogin,
}) => {
  const { signIn } = useFacebookSignIn(appId, response => {
    if (response.authResponse) {
      attemptSocialLogin({
        provider: SocialLoginProvider.Facebook,
        token: response.authResponse.accessToken!,
        redirectToJoin,
        redirectToSisu,
      });
    }
  });

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    signIn();
  };

  if (view === 'icon') {
    return (
      <SocialButtonIconViewBase
        className={c(s['root'], s['icon'], className)}
        biData={biData}
        onClick={onClick}
      />
    );
  }

  return (
    <SocialButtonBase
      className={c(s['root'], className)}
      biData={biData}
      onClick={onClick}
      aria-label="Facebook"
    >
      {children}
    </SocialButtonBase>
  );
};
SocialButtonFacebook.displayName = 'SocialButtonFacebook';

export default SocialButtonFacebook;
